import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Preserve back/forward restoration except for explicit section destinations.
    if (navigationType === 'POP' && !hash) return;

    if (hash) {
      // Routes can render asynchronously. Wait for the actual section rather
      // than guessing with a fixed delay, including on direct URL visits.
      let id: string;
      try { id = decodeURIComponent(hash.slice(1)); }
      catch { return; }
      const deadline = performance.now() + 3000;
      let frame = 0;
      const findTarget = () => {
        const target = document.getElementById(id);
        if (target) {
          frame = window.requestAnimationFrame(() => {
            target.scrollIntoView({ behavior: "instant", block: "start" });
          });
        } else if (performance.now() < deadline) {
          frame = window.requestAnimationFrame(findTarget);
        }
      };
      frame = window.requestAnimationFrame(findTarget);
      return () => window.cancelAnimationFrame(frame);
    }

    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
}
